import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for Setup Passkey Skipped event.
 */
export type SetupPasskeySkippedProps = EventProps

/**
 * @event setup_passkey_skipped
 */
export const SetupPasskeySkippedAnalytics = createAnalyticsStatic<SetupPasskeySkippedProps>(
    ANALYTICS_EVENTS.PASSKEY.SETUP_SKIPPED,
)

export default SetupPasskeySkippedAnalytics
